// -- import * as _ from "lodash-es"
import * as biz_data_helper from "../../shared/biz_data_helper"
import * as api from "../../shared/api"
import * as _date from "date-fns"

const content_type = "sPlant_Temp_Quotation"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const descriptor = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)
const cost_biz_data = new biz_data_helper.base_entity_helper(
  'sPlant_Temp_Quotation_Other_Cost_Detail',
  create,
  descriptor
)
const quotation_item_detail_biz_data = new biz_data_helper.base_entity_helper(
  'sPlant_Temp_Quotation_Item_Detail',
  create,
  descriptor
)
const quotation_process_detail_biz_data = new biz_data_helper.base_entity_helper(
  'sPlant_Temp_Quotation_Process_Detail',
  create,
  descriptor
)
const fields = {
  temp_quotation: [
    { key: "action", label: "操作", type: "button", button: { type: "text", icon_class: "iconfont icon-copy" }, thStyle: { width: "60px" }, stickyColumn: true },
    { key: "id", label: "编号", sortable: true, type: "button", button: { type: "text" }, thStyle: { width: "60px" } },
    { key: 'tempApplyNum', label: '临时报价申请编号', sortable: true, thStyle: { width: "125px" } },
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true,
      thStyle: {
        width: "5rem"
      }
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "12rem" },
      type: "short"
    },
    { key: 'AccountNum', label: '客户账户', sortable: true },
    {
      key: 'custName', label: '客户名称', sortable: true, type: "short",
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "quotationType",
      label: "报价类型",
      sortable: true,
    },

    { key: 'quotationQty', label: '报价数量', sortable: true, type: "number", required: true },
    { key: 'quotationName', label: '报价名称', sortable: true, required: true },
    { key: 'applyCompleteTime', label: '申请完成时间', sortable: true, type: "datetime" },
    { key: "tempItemNum", label: "临时物料编号", sortable: true, type: "button", button: { type: "text" } },
    {
      key: 'tempItemName', label: '临时物料名称', sortable: true, type: "textarea", required: true,
      thStyle: {
        width: "12rem"
      }
    },
    { key: 'ItemId', label: '物料编号', sortable: true, type: "button", button: { type: "text" } },
    {
      key: 'ItemName', label: '物料名称', sortable: true, type: "textarea", required: true,
      thStyle: {
        width: "12rem"
      }
    },
    { key: 'quotationPrice', label: '报价', sortable: true, type: "just_number", required: true },
    { key: 'Description', label: '描述', sortable: true, type: "short", thStyle: { width: "8rem" } },
    {
      key: 'Accessory',
      label: '附件',
      type: "button",
      button: {
        type: "text",
        icon_class: "iconfont icon-fujian",
        label: "",
        show_label: true
      },
      thStyle: { width: "70px" }
    },
    { key: 'is_return', label: '是否退回', type: "boolean" },
    {
      key: 'return_reason', label: '退回原因', sortable: true, type: "textarea", required: true,
      thStyle: {
        width: "12rem"
      }
    },
    { key: 'is_approved', label: '审批状态', type: "boolean" },
    { key: 'approved_by_username', label: '审批人', sortable: true },
    { key: 'create_by_username', label: '创建人', sortable: true },
    { key: 'create_at', label: '创建时间', sortable: true, type: "datetime" },

  ],
  other_cost: [
    { key: "id", label: "编号", sortable: true },
    { key: "QuotationId", label: "报价id", sortable: true },
    { key: "CostId", label: "成本id", sortable: true },
    { key: "CostName", label: "成本名称", sortable: true },
    { key: "Cost", label: "成本金额", sortable: true },
    { key: "Description", label: "备注", sortable: true },
  ]
}

const dataForm = {}
const validatePositive = (rule, value, callback) => {
  if (!value && value != 0) { // 空值（未填写）
    callback(new Error('请输入数值'))
  }
  if (typeof value !== 'number') {
    callback(new Error('请输入有效数字！'))
  }
  if (value <= 0) { // 小于0
    callback(new Error('必须大于0！'))
  }
  else
    callback()
}

///前端验证
const rules = {
  AccountNum: [
    { required: true, message: '请选择客户', trigger: 'change' }
  ],
  dataAreaId: [
    { required: true, message: '请选择销售公司', trigger: 'change' }
  ],
  quotationType: [
    { required: true, message: '请选择报价类型', trigger: 'change' }
  ],
  quotationName: [
    { required: true, message: '请填写报价名称', trigger: 'blur' }
  ],
  quotationQty: [
    { required: true, validator: validatePositive, trigger: 'blur' },
  ],
  applyCompleteTime: [
    { type: 'date', required: true, message: '请选择时间', trigger: 'change' }
  ],
}
const temp_item_rules = {
  ItemName: [{ required: true, message: '请填写物料名称', trigger: 'blur' }],
  quotationPrice: [
    { required: true, validator: validatePositive, trigger: 'blur' },
  ],
}
const methods = {
  async deleteOtherCost(_params) {
    let result = await cost_biz_data
      .removeAction({
        params: { id: _params.id },
        fields: ['id']
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async saveOtherCost(_params) {
    if (!_params.id) {
      let result = await cost_biz_data
        .insertAction({
          params: _params,
          fields: ['id']
        })
        .run()

      if (
        result &&
        result[0].result &&
        result[0].result.data &&
        result[0].result.data.ActionResult &&
        result[0].result.data.ActionResult.Result &&
        result[0].result.data.ActionResult.Result.Data.length > 0
      ) {
        return result[0].result.data.ActionResult.Result.Data
      } else {
        return null
      }
    } else {
      let result = await cost_biz_data
        .updateAction({
          params: _params,
          fields: ['id']
        })
        .run()

      if (
        result &&
        result[0].result &&
        result[0].result.data &&
        result[0].result.data.ActionResult &&
        result[0].result.data.ActionResult.Result &&
        result[0].result.data.ActionResult.Result.Data.length > 0
      ) {
        // console.log(result[0].result.data.ActionResult.Result.Data)
        return result[0].result.data.ActionResult.Result.Data
      } else {
        return null
      }
    }
  },
  async getOtherCost(_params) {
    let result = await cost_biz_data
      .selectAction({
        params: _params,
        fields: _.map(fields.other_cost, "key")
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async getData(_params) {
    let detail_biz_data = new biz_data_helper.base_entity_helper("get_temp_quotation_list", {}, {})
    let f = _.map(fields.default, "key")
    let result = await detail_biz_data.execAction({
      params: _params,
      fields: f
    }).run()
    // console.log(result)
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //保存附件
  async updateAccessory(params) {
    let _actions = []
    for (var k in params) {
      if (k == "edit" && params[k].length > 0) {
        _actions.push(
          biz_data.updateAction({
            params: params[k],
            fields: ["id"]
          }).action({})
        )
      }
    }
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let is_error = false
      _.each(result.data.BatchResult.Actions, (t) => {
        if (!t.Result.Data) {
          is_error = true
        }
      })
      if (is_error) return null
      else {
        let rt = { add: [], edit: [], delete: [] }
        _.each(result.data.BatchResult.Actions, (t) => {
          if (t.Code.indexOf("data/u/") > -1) rt.edit = t.Result.Data[0]
        })
        return rt
      }
    } else {
      return null
    }
  },
  //保存正式物料基础信息
  async saveItemData(params) {
    let result = null
    let _actions = []
    _actions.push(
      biz_data.updateAction({
        params: params,
        fields: ['id', 'ItemId', 'ItemName', 'Description']
      }).action({})
    )
    result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let rt = []
      rt = result.data.BatchResult.Actions[0].Result.Data[0]
      return rt
    } else {
      return null
    }
  },
  //保存临时物料基础信息
  async saveTempItemData(params) {
    let result = null
    let _actions = []

    const code_biz_data = new biz_data_helper.base_entity_helper("get_seq", {}, {})
    //获取code
    let _p = {
      type: "T",
      date: _date.format(new Date(), "yyyy-MM-dd")
    }
    _actions.push(
      code_biz_data
        .execAction({
          params: _p,
          fields: ["seq"]
        })
        .action({
          output_last_item_map: {
            seq: "tempItemNum"
          }
        })
    )
    _actions.push(
      biz_data.updateAction({
        params: params,
        fields: ['id', 'tempItemNum', 'tempItemName', 'Description']
      }).action({
        mixin_last_item_map: {
          tempItemNum: "tempItemNum"
        }
      })
    )
    result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let rt = []
      rt = result.data.BatchResult.Actions[1].Result.Data[0]
      return rt
    } else {
      return null
    }
  },
  async copyData(params) {
    let result = null
    //新增
    params = _.cloneDeep(params)
    delete params.id
    const code_biz_data = new biz_data_helper.base_entity_helper("copy_quotation_info", {}, {})
    //获取code
    let _p = params
    result = await code_biz_data
      .execAction({
        params: _p,
        fields: [""]
      })
      .run()

    if (
      result &&
      result[0].result
    ) {
      return true
    } else {
      return false
    }
  },
  async saveData(params) {
    let result = null
    let _actions = []
    if (params.id == "") {
      //新增
      delete params.id
      const code_biz_data = new biz_data_helper.base_entity_helper("get_seq", {}, {})
      //获取code
      let _p = {
        type: "CPTQ",
        date: _date.format(new Date(), "yyyy-MM-dd")
      }
      _actions.push(
        code_biz_data
          .execAction({
            params: _p,
            fields: ["seq"]
          })
          .action({
            output_last_item_map: {
              seq: "tempApplyNum"
            }
          })
      )
      _actions.push(
        biz_data.insertAction({
          params: params,
          fields: _.map(fields.temp_quotation, "key")
        }).action({
          mixin_last_item_map: {
            tempApplyNum: "tempApplyNum"
          }
        })
      )
    } else {
      //修改
      let result = await biz_data
        .updateAction({
          params: params,
          fields: _.map(fields.temp_quotation, "key")
        }).run()
      if (
        result &&
        result[0].result &&
        result[0].result.data &&
        result[0].result.data.ActionResult &&
        result[0].result.data.ActionResult.Result &&
        result[0].result.data.ActionResult.Result.Data.length > 0
      ) {
        return result[0].result.data.ActionResult.Result.Data[0]
      } else {
        return null
      }
    }
    result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let rt = []

      if (params.id)
        rt = result.data.BatchResult.Actions[1].Result.Data
      else
        rt = result.data.BatchResult.Actions[1].Result.Data
      return rt
    } else {
      return null
    }
  }
}
export { biz_data, dataForm, fields, methods, rules, temp_item_rules }

